import { ClientError } from '.';

export const getApiError = (error: unknown, callback?: (arg0: string) => void) => {
  if (callback && (error instanceof Error || error instanceof ClientError)) {
    callback(error.message || 'Something went wrong!');
  }

  if (error instanceof ClientError) return;

  throw error;
};
